import * as React from "react";
import { Button, ButtonProps, SxProps } from "@mui/material";

interface IconButtonProps extends Omit<ButtonProps, "size"> {
  icon: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "contained" | "outlined" | "text";
  buttonColor?: string;
  gradient?: boolean;
  sx?: SxProps;
}

const sizeStyles = {
  xs: { padding: "4px", minWidth: "16px", height: "16px", fontSize: "0.6rem" },
  sm: { padding: "6px", minWidth: "26px", height: "26px", fontSize: "0.75rem" },
  md: { padding: "8px", minWidth: "30px", height: "30px", fontSize: "0.8rem" },
  lg: { padding: "10px", minWidth: "34px", height: "34px", fontSize: "0.85rem" },
};

const iconSizes = { xs: "4px", sm: "12px", md: "14px", lg: "16px" };

export default function IconButton({ icon, size = "sm", variant = "contained", buttonColor = "#10b981", gradient = false, sx = {}, ...props }: IconButtonProps) {
  const buttonSx: SxProps = {
    ...sizeStyles[size],
    borderRadius: "6px",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "none",
    ...(variant === "contained" && !gradient ? { bgcolor: buttonColor, "&:hover": { bgcolor: buttonColor, opacity: 0.85, boxShadow: "none" } } : {}),
    ...(gradient ? { background: `linear-gradient(135deg, ${buttonColor} 0%, ${buttonColor}cc 100%)`, "&:hover": { background: `linear-gradient(135deg, ${buttonColor}cc 0%, ${buttonColor}aa 100%)`, boxShadow: "none" } } : {}),
    ...sx,
  };

  return (
    <Button variant={variant} sx={buttonSx} {...props}>
      <span style={{ fontSize: iconSizes[size], display: "flex", alignItems: "center", lineHeight: 1, transform: size === "xs" ? "scale(0.7)" : "none" }}>
        {icon}
      </span>
    </Button>
  );
}
